import { useState } from "react";
import { Box, Stack } from "@mui/material";
import { ReactComponent as ButtonShare } from "../../../assets/icons/ShareButton.svg";
import { ReactComponent as ButtonLocation } from "../../../assets/icons/ButtonLocation.svg";
import { ReactComponent as ChatButton } from "../../../assets/icons/ChatButton.svg";
import { useTranslation } from "react-i18next";
import { FacebookShareButton } from "react-share";
import MapScreenModal from "../../MapScreen";


export default function UtilitiesStratto() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState<string>("ES");
  const [openModal,setOpenModal] = useState(false);
  const handleClickES = () => {
    setLanguage("EN");
    i18n.changeLanguage("en");
  };

  const handleClickEN = () => {
    setLanguage("ES");
    i18n.changeLanguage("es");
  };
  const handleClickModalMap = () => {
    console.log('open');
    setOpenModal(true)
  }
  const handleClose = () => {
    setOpenModal(false); 
  }
  const shareUrl = "https://showroom.athum.com";
  return (
    <Box
      sx={{
        position: "absolute",
        right: "10px",
        bottom: "16px",
        zIndex:1000
      }}
    >
      <Stack direction="column" spacing={2} alignItems="center">
        <FacebookShareButton url={shareUrl}>
          <ButtonShare className="utiliti-stratto" />
        </FacebookShareButton>
        <div
          style={{
            color: "#fff",
            cursor: "pointer",
          }}
        >
          {language === "ES" ? (
            <span onClick={handleClickES} className="utiliti-stratto">
              ES
            </span>
          ) : (
            <span onClick={handleClickEN} className="utiliti-stratto">
              EN
            </span>
          )}
        </div>
        <div onClick={handleClickModalMap}>
          <ButtonLocation className="utiliti-stratto" />
        </div>
        <ChatButton className="utiliti-stratto" />
      </Stack>
      <MapScreenModal onClose={handleClose} open={openModal}/>
    </Box>
  );
}
